import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InvoiceDatesInfoComponent } from './invoice-dates-info.component';

@NgModule({
  declarations: [ InvoiceDatesInfoComponent ],
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  exports: [ InvoiceDatesInfoComponent ]
})
export class InvoiceDatesInfoModule {

}
